import { createUseStyles } from "react-jss";
import { ITheme } from "../../constants/theme";
import {
  BreakPointDesktop,
  BreakPointMobile,
  BreakPointTablet,
} from "../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {},
  rootContent: {
    height: "100%",
    overflow: "initial",
    scrollbarWidth: "none",
    contain: "layout",
  },
  introCard: {
    paddingTop: theme.spacing.space48 * 5,
    [BreakPointTablet]: {
      paddingTop: theme.spacing.space48,
    },
    [BreakPointMobile]: {
      paddingTop: theme.spacing.space32,
    },
  },
  lastGameCateroy: {
    marginBottom: theme.spacing.space16,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    zIndex: 2,
    gap: theme.spacing.space16,
    [BreakPointDesktop]: {
      gap: 44,
    },
  },
}));
